export default "/assets/images/mila-air-mini.9b5c0aa7ceabce39.webp";